<div class="input-group--input">
	@if (type !== 'number') {
		<input
			[type]="type"
			[attr.aria-invalid]="showError"
			[formControl]="formControl | fromAbstractToFormControl"
			class="form-control"
			[formlyAttributes]="field"
			[class.is-invalid]="showError" />
	} @else {
		<input
			type="number"
			[attr.aria-invalid]="showError"
			[formControl]="formControl | fromAbstractToFormControl"
			class="form-control"
			[formlyAttributes]="field"
			[class.is-invalid]="showError" />
	}
</div>
@if (to.buttons?.length) {
	<div
		[ngClass]="{
			'input-group-append--right': to.buttonsPosition === 'right',
			'input-group-append--left': to.buttonsPosition === 'left'
		}">
		@for (button of to.buttons; track $index) {
			<button class="btn btn--default" [ngClass]="button.class" (click)="button.onClick($event)" type="button">
				@if (button.icon) {
					<lu-icon class="btn__ico" [icon]="button.icon"></lu-icon>
				}
				@if (button.label) {
					<span class="btn__txt">{{ button.label }}</span>
				}
			</button>
		}
	</div>
}
